import { render } from "./Menu.vue?vue&type=template&id=51989c68"
const script = {}

import "./Menu.vue?vue&type=style&index=0&id=51989c68&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__